import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-load-watch-overview',
  templateUrl: './load-watch-overview.component.html',
  styleUrls: ['./load-watch-overview.component.css', './../../../fleetdiag-dashboard-pro/fleetdiag-dashboard-pro.component.scss']
})
export class LoadWatchOverviewComponent implements OnInit {

  menuItems = [
    { label: 'داشبورد', route: 'dashboard', icon: 'fa-home' },
    { label: 'نمودار‌ها', route: 'chart', icon: 'fa-bar-chart' },
    { label: 'سلامت ژنراتور ', route: 'generator-health', icon: 'fa-heartbeat' },
    { label: 'عملکرد', route: 'performance', icon: 'fa-tachometer' },
    { label: 'انرژی', route: 'energy', icon: 'fa-bolt' },
    { label: 'ولتاژ و جریان', route: 'voltage-current', icon: 'fa-plug' },
    // { label: 'اطلاعات', route: 'fuel-efficiency', icon: 'fa-info-circle' },
  ];


  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
  }

  goBack() {
    this.router.navigate(['../'], { relativeTo: this.route });
  }


}
